import { authedJson } from '../api/client';

export type EpicStatus = 'ACTIVE' | 'DONE' | 'ARCHIVED';

export interface Epic {
  epicId: string;
  workspaceId: string;
  name: string;
  description: string;
  status: EpicStatus;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const epicsApi = {
  list: (workspaceId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ epics: Epic[] }>(`/workspaces/${workspaceId}/epics`, { method: 'GET' }, getToken, doRefresh),

  create: (workspaceId: string, name: string, description: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Epic>(
      `/workspaces/${workspaceId}/epics`,
      { method: 'POST', body: JSON.stringify({ name, description }) },
      getToken,
      doRefresh,
    ),

  get: (workspaceId: string, epicId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Epic>(`/workspaces/${workspaceId}/epics/${epicId}`, { method: 'GET' }, getToken, doRefresh),

  update: (
    workspaceId: string,
    epicId: string,
    updates: Partial<Pick<Epic, 'name' | 'description' | 'status'>>,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Epic>(
      `/workspaces/${workspaceId}/epics/${epicId}`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, epicId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(`/workspaces/${workspaceId}/epics/${epicId}`, { method: 'DELETE' }, getToken, doRefresh),
};
